module.exports = __webpack_public_path__ + "static/media/train9.639a7b92.jpg";